module.exports = __webpack_public_path__ + "static/media/bh.6d94e198.svg";